import {
  AddDictionary,
  CommonActions,
  CommonTypes,
  HandlerConfirmCode,
  IsHideSpinnerLoading,
  SetBackLinkFromDetails,
  SetCartCount,
  SetConfirmationControl,
  SetConfirmServiceList,
  SetConfirmTexts,
  SetEndTime,
  SetErrorControlById,
  SetHeader,
  SetMessages,
  SetNavigationHeaderForMobileView,
  SetOrderCode,
  SetPhones,
  SetSmsResponseCode,
  SetStartTime,
  SetUserInfo,
  SetValidationsText,
} from '@modules/shared/store/common.actions';
import { DictionaryState } from '../models/dictionary.interface';
import { Control } from '@modules/agreements/models/control.interface';
import { Confirmation, Contact, NeedCodeResponse } from '@codegen';
import { ConfirmationControl } from '../models';
import { UserInfo } from '../models/user-info.model';

export class CommonState {
  public cartCount: string;
  public orderCode: string;
  public dictionaries: DictionaryState[] = [];
  public confirmTexts: Pick<NeedCodeResponse, 'header' | 'message'> = {
    header: '',
    message: '',
  };
  public validationsText: string;
  public confirmationControl: ConfirmationControl;
  public smsResponseCode: string;
  public userInfo: UserInfo;
  public isDetails: boolean;
  public backLinkFromDetails: string;
  public errorsControls: Control[] = [];
  public confirmationServices: Confirmation[];
  public navTitleForMobileView: string;
  public phones: Contact[] = [];
  public messengers: Contact[] = [];
  public startTime: string;
  public endTime: string;
  public isShowLoader: boolean = false;
  public confirmCodeResult: NeedCodeResponse;
  public isHideSpinnerLoading: boolean = true;
}

const pushItemInItemsArray = (
  item: DictionaryState,
  itemsArray: DictionaryState[]
): DictionaryState[] | Control[] => {
  let tempArray = itemsArray;
  tempArray.forEach(() => {
    if (
      tempArray.length !== 0 &&
      !tempArray.some(itemArray => itemArray.id === item.id)
    ) {
      tempArray = tempArray.concat(item);
    }
  });
  tempArray = tempArray.map(itemArray => {
    if (itemArray.id === item.id) {
      return (itemArray = item);
    }
    return itemArray;
  });
  if (tempArray.length === 0) {
    tempArray = tempArray.concat(item);
  }
  itemsArray = tempArray;
  return itemsArray;
};

export function reducer(
  state = new CommonState(),
  action: CommonActions
): CommonState {
  switch (action.type) {
    case CommonTypes.SetOrderCode:
      return {
        ...state,
        orderCode: (action as SetOrderCode).payload,
      };
    case CommonTypes.SetCartCount:
      return {
        ...state,
        cartCount: (action as SetCartCount).payload,
      };
    case CommonTypes.AddDictionary:
      return {
        ...state,
        dictionaries: pushItemInItemsArray(
          (action as AddDictionary).payload,
          state.dictionaries
        ),
      };
    case CommonTypes.SetConfirmTexts:
      return {
        ...state,
        confirmTexts: (action as SetConfirmTexts).payload,
      };
    case CommonTypes.SetValidationsText:
      return {
        ...state,
        validationsText: (action as SetValidationsText).payload,
      };
    case CommonTypes.SetConfirmationControl:
      return {
        ...state,
        confirmationControl: (action as SetConfirmationControl).payload,
      };
    case CommonTypes.SetSmsResponseCode:
      return {
        ...state,
        smsResponseCode: (action as SetSmsResponseCode).payload,
      };
    case CommonTypes.SetUserInfo:
      return {
        ...state,
        userInfo: (action as SetUserInfo).payload,
      };
    case CommonTypes.SetHeader: {
      return {
        ...state,
        isDetails: (action as SetHeader).payload,
      };
    }
    case CommonTypes.SetBackLinkFromDetails: {
      return {
        ...state,
        backLinkFromDetails: (action as SetBackLinkFromDetails).payload,
      };
    }
    case CommonTypes.SetErrorControlById: {
      return {
        ...state,
        errorsControls: pushItemInItemsArray(
          (action as SetErrorControlById).payload,
          state.errorsControls
        ) as Control[],
      };
    }
    case CommonTypes.SetConfirmServiceList: {
      return {
        ...state,
        confirmationServices: (action as SetConfirmServiceList).payload,
      };
    }
    case CommonTypes.SetNavigationHeaderForMobileView: {
      return {
        ...state,
        navTitleForMobileView: (action as SetNavigationHeaderForMobileView)
          .payload,
      };
    }
    case CommonTypes.SetPhones:
      return {
        ...state,
        phones: (action as SetPhones).payload,
      };
    case CommonTypes.SetMessages:
      return {
        ...state,
        messengers: (action as SetMessages).payload,
      };
    case CommonTypes.SetStartTime:
      return {
        ...state,
        startTime: (action as SetStartTime).payload,
      };
    case CommonTypes.SetEndTime:
      return {
        ...state,
        endTime: (action as SetEndTime).payload,
      };
    case CommonTypes.ShowSpinnerLoading: {
      return {
        ...state,
        isShowLoader: true,
      };
    }
    case CommonTypes.HideSpinnerLoading: {
      return {
        ...state,
        isShowLoader: false,
      };
    }
    case CommonTypes.HandlerConfirmCode: {
      return {
        ...state,
        confirmCodeResult: (action as HandlerConfirmCode).payload,
      };
    }
    case CommonTypes.IsHideSpinnerLoading: {
      return {
        ...state,
        isHideSpinnerLoading: (action as IsHideSpinnerLoading).payload,
      };
    }
    default: {
      return state;
    }
  }
}
